import endpoints from "api/endpoints";

export default (
  { resultKey = "isPaymentDeleted", paymentId } = {
    resultKey: "isPaymentDeleted",
  }
) => ({
  url: endpoints.getActionPaymentUrl(paymentId),
  transform: (response) => !response.error,
  transformResult: (response) => ({
    [resultKey]: !response.error,
  }),
  queryKey: endpoints.getActionPaymentUrl(paymentId),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: "application/json",
    },
    method: "DELETE",
  },
  update: {},
  updateResult: {
    [resultKey]: (prevResult, result) => result,
  },
});
